define('koLoadUXModule',['knockout', 'moduleLoader'], function (ko, moduleLoader) {
    "use strict";

    ko.bindingHandlers.loadUXModule = {
        init: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
            if (element.getAttribute('data-ux-state') === 'pending')
                moduleLoader.loadPendingModules(element);
        },

        update: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
            //element.setAttribute('data-ux-state', 'pending');
            //moduleLoader.loadPendingModules(element);
        }
    }
});
